module.exports = __webpack_public_path__ + "static/media/find-in-page.57dfbc70.svg";